module.exports = __webpack_public_path__ + "img/blog5.85f1a846.jpeg";